'use strict';
angular.module('appMarketplace')
    .controller('UpdatePasswordCtrl', ['$scope', '$location', '$state', '$window', '$stateParams', 'NotificationService',
                                      'PasswordService', 'NavigationService', 'UrlService', 'UserService',
                                      function ($scope, $location, $state, $window, $stateParams, NotificationService,
                                                PasswordService, NavigationService, UrlService, UserService) {

        PasswordService.getValidPasswordLength(function successCallback(data) {
            $scope.minPasswordLength = data.minPasswordLength;
            $scope.maxPasswordLength = data.maxPasswordLength;

            $scope.actions = [];
            $scope.manualUpdate = $location.search().manualUpdate === "true" || $stateParams.manualUpdate; //true if user selected update password, false if password is expired
            if ($scope.manualUpdate) {
                $scope.actions.push("Close");
            }
            $scope.requirementsTooltip = kendo.template(angular.element("#requirementsTooltipTemplate").html());

            var windowTitle = "Change" + (!$scope.manualUpdate ? " expired" : "") + " password";
            $scope.window = angular.element("#updatePasswordForm").kendoWindow({
                actions: $scope.actions,
                modal: true,
                pinned: true,
                resizable: false,
                title: windowTitle,
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded(UrlService.getHashFromUrl() === 'update-password');
                },
                deactivate: function () {
                    $scope.validator.destroy();
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };

            var formErrorTemplate = kendo.template(angular.element("#formErrorTemplate").html());
            $scope.validator = angular.element("#updatePasswordForm").kendoValidator({
                errorTemplate: formErrorTemplate,
                messages: {
                    newPasswordLength: function () {
                        return getPasswordLengthValidationMessage()
                    },
                    newPasswordCase: "Password should contain at least one upper case, one lower case and one numeric character",
                    newPasswordRepeatedChars: 'You may NOT have a password consisting of MORE THAN two consecutive identical characters or MORE than one pair of identical characters.',
                    repeatPassword: "Passwords don't match",
                    required: "Field is required"
                },
                rules: {
                    newPasswordLength: function (input) {
                        if (input.is("[name=newPassword]") && $scope.minPasswordLength && $scope.maxPasswordLength) {
                            var newPasswordLength = input.val().length;
                            return newPasswordLength && newPasswordLength >= $scope.minPasswordLength && newPasswordLength <= $scope.maxPasswordLength;
                        }
                        return true;
                    },
                    newPasswordCase: function (input) {
                        if (input.is("[name=newPassword]")) {
                            return PasswordService.validatePasswordCase(input.val());
                        }
                        return true;
                    },
                    newPasswordRepeatedChars: function (input) {
                        if (input.is("[name=newPassword]")) {
                            return PasswordService.validatePasswordRepeatedChars(input.val());
                        }
                        return true;
                    },
                    repeatPassword: function (input) {
                        if (input.is("[name=repeatPassword]")) {
                            return input.val() === $scope.newPassword;
                        }
                        return true;
                    }
                }
            }).data("kendoValidator");

            $scope.updatePassword = function () {
                if (!$scope.validateForm()) {
                    return;
                }
                PasswordService.updatePassword($scope.oldPassword, $scope.newPassword,
                    function successCallback() {
                        NotificationService.showSuccessMessage('Updated password');
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.passwordUpdateNeeded = false;
                        });
                        $scope.window.close();
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        $scope.formErrors = [];
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors.push(error);
                        });
                    })
            };

            $scope.validateForm = function () {
                return $scope.validator.validate();
            };

            var getPasswordLengthValidationMessage = function () {
                return "Password length should be between " + $scope.minPasswordLength + " and " + $scope.maxPasswordLength + " characters"
            }
        }, function errorCallback(responseError) {
            NotificationService.showValidationErrors(responseError);
        });
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/controllers/update-password-ctrl.js
// module id = 257
// module chunks = 21